import { fromJSON } from "postcss";

export enum FieldDataTypes {
    STRING = 'string',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    DATE = 'date'
}

export interface FieldColSize {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
}

export interface Field {
    id?: string;
    name?: string;
    description?: string;
    label?: string;
    dataType?: FieldDataTypes;
    required?: boolean;
    defaultValue?: any;
    hidden?: boolean;
    formTag?: string;
    parent?: Field | null;
    colSize?: FieldColSize;

    render: () => JSX.Element;
    renderEditor: (field: Field, selectedComponent?: unknown, setSelectedComponent?: unknown, deleteComponent?: (c: Field) => void) => JSX.Element;
    renderPropertiesEditor: (field: Field, updateField: any, context?: { formFieldNames?: { value: string; label: string }[] }) => JSX.Element;
    fromJSON: (json: any, parent: Field | null) => Field;
    toJSON: () => any;
}